import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const usersService = {
  getAllUsers,
  getUser,
  createUser,
  updateUser,
  updateUserStatus,
  updateUserLoginAccess,
  unlockUser,
}

const MODULE = { USERS: 'users' }
const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = {
    page: filter?.pageNumber,
    size: filter?.pageSize,
  }
  if (filter?.isActive !== undefined && filter?.isActive !== null && filter?.isActive !== '') {
    params.is_active = filter.isActive
  }
  filter?.searchArray?.forEach((word, idx) => {
    if (word !== null && word !== '') params[`search_words[${idx}]`] = word
  })
  return params
}

export async function getAllUsers(filter) {
  return apiHelper(API_URL).get(`/${MODULE.USERS}`, { params: buildParams(filter) })
}

export async function getUser(uuid) {
  return apiHelper(API_URL).get(`/${MODULE.USERS}/${uuid}`)
}

export async function createUser(data) {
  const body = {
    name: data.name,
    email: data.email,
    role_uuid: data.roleUuid,
    agent_code: data.agentCode || null,
  }
  return apiHelper(API_URL).post(`/${MODULE.USERS}`, body)
}

export async function updateUser(uuid, data) {
  const body = {
    name: data.name,
    email: data.email,
    role_uuid: data.roleUuid,
    agent_code: data.agentCode || null,
  }
  return apiHelper(API_URL).put(`/${MODULE.USERS}/${uuid}`, body)
}

export async function updateUserStatus(uuid, isActive) {
  return apiHelper(API_URL).patch(`/${MODULE.USERS}/${uuid}/status`, { is_active: isActive })
}

export async function updateUserLoginAccess(uuid, isAllowLogin) {
  return apiHelper(API_URL).patch(`/${MODULE.USERS}/${uuid}/login-access`, { is_allow_login: isAllowLogin })
}

export async function unlockUser(uuid) {
  return apiHelper(API_URL).patch(`/${MODULE.USERS}/${uuid}/unlock`)
}
